import { X, Warning } from '@phosphor-icons/react'
import { useState } from 'react'
import { supabase } from '../../lib/supabase'

export default function RemoveMemberModal({ isOpen, onClose, member, onSuccess }) {
  const [loading, setLoading] = useState(false)

  if (!isOpen || !member) return null

  const handleRemove = async () => {
    setLoading(true)
    
    try {
      // Delete database records
      await supabase.from('event_confirmations').delete().eq('user_id', member.id)
      await supabase.from('attendance_records').delete().eq('user_id', member.id)
      await supabase.from('group_members').delete().eq('user_id', member.id)
      await supabase.from('users').delete().eq('id', member.id)

      // Delete auth user
      await supabase.functions.invoke('delete-user', {
        body: { userId: member.id }
      })

      onSuccess()
      onClose()
    } catch (error) {
      alert('Failed to remove member')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6">
        <button onClick={onClose} className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-lg">
          <X size={20} />
        </button>
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Warning size={32} className="text-red-600" weight="fill" />
          </div>
        </div>
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Remove <strong>{member.name}</strong>?</h2>
          <p className="text-sm text-[#475569] font-regular">This will permanently delete all their data and cannot be undone.</p>
        </div>
        <div className="flex gap-3">
          <button onClick={onClose} disabled={loading} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50">
            Cancel
          </button>
          <button onClick={handleRemove} disabled={loading} className="flex-1 px-4 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700">
            {loading ? 'Removing...' : 'Remove'}
          </button>
        </div>
      </div>
    </div>
  )
}